module.exports = __webpack_public_path__ + "aad08f594e066a08bb1ecb951984a2ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-7.png
// module id = 1754
// module chunks = 0